import { ChevronRightIcon } from '@/components/ui/icons'
import { cn } from '@/lib/utils'

export interface OpenRowButtonProps {
  /** Accessible name for the icon-only control — the action it performs ("Open", "Review"). */
  label: string
  enabled: boolean
  onClick?: () => void
}

/**
 * The chevron affordance that opens an overview row. Shared by section rows and
 * section-backed prerequisites so both carry the same weight in the list.
 */
export function OpenRowButton({ label, enabled, onClick }: OpenRowButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      disabled={!enabled}
      onClick={
        enabled
          ? (e) => {
              // The row around it carries the same action — without this the card's
              // handler fires too and the open runs twice.
              e.stopPropagation()
              onClick?.()
            }
          : undefined
      }
      className={cn(
        'grid h-10 w-10 place-items-center rounded-full text-subtle',
        'focus-visible:ring-2 focus-visible:ring-focus focus-visible:outline-none',
        enabled ? 'hover:bg-surface-hover hover:text-heading' : 'cursor-not-allowed opacity-40',
      )}
    >
      <ChevronRightIcon />
    </button>
  )
}
